// extracted by mini-css-extract-plugin
module.exports = {"note":"_2i1YNR","noteBig":"Vr2ckO"};